import { toast } from "sonner";

export const CA = "9AyAZUys1dqszFkVTRx9QSF2jMC1znL2mUQdhj3jpump";
export const PUMP_URL = `https://pump.fun/coin/${CA}`;
export const X_URL = "https://x.com/WebsiteFullPort";
export const COIN_IMG = "/coin.png";

export const NARRATIVE_TITLE = "🇺🇸 $TATE — THE NEXT CHAPTER OF THE MEME MOVEMENT 🐈";

export const NARRATIVE = [
  "In a world where attention is everything, legends aren't built by following the crowd — they're built by making noise. Introducing $TATE, a memecoin inspired by the bold, unapologetic energy of Donald Trump and the viral culture behind $CATE.",
  "Combining Trump's larger-than-life personality with the meme-driven spirit of $CATE, $TATE represents a new wave of internet culture: louder memes, a stronger community, and a mission to stand out in an overcrowded market. It's not just another ticker chasing a quick pump — it's a brand built around humor, controversy, community, and the power of a narrative that people want to share.",
  "Why $TATE? Because the strongest memes don't need to follow trends — they create them. With a recognizable political-inspired theme, endless opportunities for viral content, and a community-first identity, $TATE has the ingredients to build lasting attention beyond a single market cycle.",
  "The vision is simple: keep the memes flowing, keep the community engaged, and keep the story evolving. While other coins fade when the hype disappears, $TATE aims to give its community a reason to keep showing up, creating, and spreading the movement.",
];

export const NARRATIVE_PULL =
  "In the memecoin world, attention starts the fire — but community is what keeps it burning.";

export const NARRATIVE_CLOSER = "$TATE — MAKE MEMES GREAT AGAIN. 🇺🇸🔥";
export const NARRATIVE_TAGLINE = "One ticker. One movement. Unlimited meme potential.";

export const SHILL_LINES = [
  "$TATE doesn't chase the trend. The trend chases $TATE. 🇺🇸🐈",
  "Other coins bark. $TATE roars — with golden hair. MAKE MEMES GREAT AGAIN.",
  "They said a cat couldn't run for office. Then $TATE filed the paperwork. 📜",
  "Attention is the only currency that matters. $TATE prints it. 🖨️🇺🇸",
  "You can ignore $TATE. You can't unsee $TATE. 🐈🔥",
  "$CATE had nine lives. $TATE has nine rallies. And it's only Tuesday.",
  "The chart goes up because the memes never stop. Simple math. 📈",
  "Wall Street has suits. We have a cat in a suit. Different league. $TATE",
  "Every dip is just the cat crouching before the pounce. 🐾",
  "Legends aren't built by following the crowd. $TATE makes the noise.",
  "One ticker. One movement. Unlimited meme potential. $TATE 🇺🇸",
  "The loudest coin in the room just walked in. $TATE has entered the chat.",
  "Paper hands fold. Diamond paws hold. 🐾💎 $TATE",
  "This isn't a coin. It's a campaign. And the cat is winning. 🗳️",
  "Fading $TATE? Tremendous mistake. Everybody's saying it.",
  "The meme movement has a new commander-in-chief. $TATE 🐈🇺🇸",
  "Hype starts the fire. Community keeps it burning. $TATE forever. 🔥",
  "Some coins need marketing budgets. $TATE has memes and momentum.",
];

export const scrollToId = (id) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(id, { offset: -72, duration: 1.4 });
  } else {
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const copyText = async (text, label = "Copied to clipboard") => {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(label);
  } catch {
    toast.error("Copy failed — select and copy manually");
  }
};

export const xShare = (text) => {
  window.open(
    `https://x.com/intent/tweet?text=${encodeURIComponent(text)}`,
    "_blank",
    "noopener,noreferrer"
  );
};
